import { Ref } from './Ref';

export type RefSet<T extends { ref: Ref<T> }> = {
  _refSetItems: { [id: string]: T },
};

export function RefSet<T extends { ref: Ref<T> }>(): RefSet<T> {
  return { _refSetItems: {} };
}

export namespace RefSet {
  export function resolve<T extends { ref: Ref<T> }>(
    set: RefSet<T>,
    ref: Ref<T>,
  ): T | null {
    return set._refSetItems[ref.id] || null;
  }

  export function update<T extends { ref: Ref<T> }>(
    set: RefSet<T>,
    value: T,
  ): RefSet<T> {
    return { _refSetItems: { ...set._refSetItems, [value.ref.id]: value } };
  }

  export function size<T extends { ref: Ref<T> }>(set: RefSet<T>): number {
    return Object.keys(set._refSetItems).length;
  }

  export function Refs<T extends { ref: Ref<T> }>(
    set: RefSet<T>,
  ): Ref<T>[] {
    return (Object
      .keys(set._refSetItems)
      .sort()
      .map(id => set._refSetItems[id].ref)
    );
  }

  // TODO: Enforce uniqueness constraints
}

export default RefSet;



// WEBPACK FOOTER //
// ./src/util/RefSet.ts